import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import ScoreDetailsSideNav from 'app-ui-componentlibrary/dist/componentLibrary/sideNavWidgets/ScoreDetailsSideNav';

export default connectDynamic(ScoreDetailsSideNav);
